// Period filter for the ledger-based revenue reports (account report, admin
// Revenue page). purchase_ledger only holds money from 2026 on, so earlier
// years are not offered: they would always read as zero.

export const LEDGER_START_YEAR = 2026;

export const YEAR_TO_DATE = 'ytd';

// "Year to Date" for the current year, then each completed year back to the
// first ledger year. The current year is not repeated as a plain year since
// it would show the same figures as Year to Date.
export const ledgerPeriodOptions = (currentYear) => {
  const options = [{ key: YEAR_TO_DATE, label: 'Year to Date' }];
  for (let year = currentYear - 1; year >= LEDGER_START_YEAR; year -= 1) {
    options.push({ key: String(year), label: String(year) });
  }
  return options;
};

// The year a selected period key stands for.
export const periodYear = (period, currentYear) =>
  period === YEAR_TO_DATE ? currentYear : parseInt(period, 10);
